import { Injectable } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable({
  providedIn: 'root'
})
export class IaithRouterService {

  constructor(private localize: LocalizeRouterService) { }

  /**
  * Toggle newid iaith y LocalizeRouterService, gan hefyd newid y route / URL
  * @param iaith ''cy', 'en'
  */
  newidIaithRouter(iaith: string): any {
    this.localize.changeLanguage(iaith, { replaceUrl: true });
  }

  /**
   * 
   * @param route Nol y route yn y iaith sydd wedi ei setio rwan
   * @returns route
   */
  cyfieithuLlwybr(route: string): string | any {
    return this.localize.translateRoute(route);
  }
}